import React from 'react'
import { Document, Page, Text, Image } from '@react-pdf/renderer';

let desc = '';
let complemento = '';
let aux = '';
let sol = '';
let aux2 = '';
let aux3 = '';


const GeneralPDF = ({ datoFun }) => (
    <>
    {
    datoFun.codigo === 5
    ?
        (
            aux2 = 'licencia por Estudio/Examen',
            aux3 = 'de licencia por estudio'
        )
    :
        null
    }
    {
        sol = '\n\n\nSolicitado el ' + datoFun.solicitado.substring(8,10) + '/' + datoFun.solicitado.substring(5,7) + '/' + datoFun.solicitado.substring(0,4)
    }
    {desc = 'En el corriente ejercicio el funcionario N° ' + datoFun.numeroFuncionario + ' ' + datoFun.nombreFuncionario + ' ha hecho uso de:\n'}
    {datoFun.codigo === 5
        ?
            aux = 'Jefe/Encargado: \nSolicito a Ud. el usufructo de ' + datoFun.dias + ' día/s ' + aux2 + ' , desde el ' + datoFun.desde.substring(8,10) + '/' + datoFun.desde.substring(5,7) + '/' + datoFun.desde.substring(0,4)
            + ' hasta el ' + datoFun.hasta.substring(8,10) + '/' + datoFun.hasta.substring(5,7) + '/' + datoFun.hasta.substring(0,4) + ' inclusive.'
        :
            null
    }
    
    <Document>
        <Page size='A4' style={{paddingTop: 35, paddingBottom: 65, paddingHorizontal: 35}}>
            <Image style={{ width: '50%'}} src="img/Institucional.jpg"/>
            <Text style={{fontSize: 24, textAlign: 'center'}}>{datoFun.titulo}</Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {datoFun.encabezado}
            </Text>
            {datoFun.llevaFirmaFuncionario
            ?
                <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', textAlign: 'right', fontFamily: 'Times-Roman'}}>
                    {datoFun.textoSolicitado}
                </Text>
            :
                null
            }
            {datoFun.llevaFirmaFuncionario
            ?
                <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaFuncionario}/>
            :
                null
            }
            {datoFun.llevaFirmaJefe
            ?
                <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                    {'Pase al Departamento de Recursos Humanos:'}
                </Text>
            :
                null
            }
            {datoFun.llevaFirmaJefe
            ?
                <Image style={{marginVertical: 5, marginLeft:300, width: 200}} src={datoFun.firmaJefe}/>
            :
                null
            }
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {'Se registró en su ficha, se incorporó al sistema'}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaSistema}/>
            {datoFun.llevaFirmaSalarioVa
            ?
                <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                    {'Se tomo nota para Salario Vacacional:'}
                </Text>
            :
                null
            }
            {datoFun.llevaFirmaSalarioVa
            ?
                <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaVacacional}/>
            :
                null
            }
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {datoFun.informeFinal}
            </Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', textAlign: 'right', fontFamily: 'Times-Roman'}}>
                {'Firma por Recursos Humanos: '}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaJefeFinal}/>
        </Page>
        {datoFun.llevaImagenFinal
        ?
            <Page size='A4' style={{paddingTop: 35, paddingBottom: 65, paddingHorizontal: 35}}>
                <Image style={{marginTop: 50, width:'100%', transform: 'rotate(-270deg)'}} src={datoFun.archivo}/>
            </Page>
        :
            null
        }
        {datoFun.llevaActa
        ?
            <Page size='A4' style={{paddingTop: 35, paddingBottom: 65, paddingHorizontal: 35}}>
                <Image style={{marginTop: 50, width:'100%', transform: 'rotate(-270deg)'}} src={datoFun.archivoActa}/>
            </Page>
        :
            null
        }
    </Document>
    </>
);



export default GeneralPDF